export const commonTranslations = {
    cancel: 'Cancel',
    delete: 'Delete',
    open: 'Open',
    back: 'Back',
    edit: 'Edit',
    loans: 'Loans',
    contacts: 'Contacts',
    email: 'Email',
    iAgree: 'I Agree',
    continue: 'Continue',
    finish: 'Finish',
    getStarted: 'Get Started',
    downloadExport: 'Download Export',
    createLabel: '+ Create {{createdLabel}}',
    saveContinue: 'Save & Continue',
    saveFinish: 'Save & Finish',
    saveAndSubmit: 'Save & Submit',
    nextPage: 'Next Page',
    saveChanges: 'Save Changes',
    submit: 'Submit',
    name: 'Name',
    enroll: 'Enroll',
    missingInformation: 'Missing information',
    primary: 'Primary',
    financial: 'Financial',
    signOut: 'Sign Out',
    signIn: 'Sign In',
    yes: 'Yes',
    no: 'No',
    areaCode: 'Area Code',
    number: 'Number',
    extension: 'Extension',
    total: 'Total',
    help: 'Help',
    incomplete: 'Incomplete',
    confirmSelection: 'Confirm Selection',
    review: 'Review',
    logout: 'Logout',
    logIn: 'Log In',
    loanGroup: 'Loan Group',
    reasonOmitted: 'Reason Omitted',
    error: 'Error',
    existingSurvey: 'Existing Survey',
    lastUpdated: 'Last Updated',
    targetPeriod: 'Target Period',
    dateSent: 'Date sent',
    reminderSent: 'Reminder sent',
    latestReviewNote: 'Latest Review Note',
    type: 'Type',
    view: 'View',
    required: 'Required',
    organization: 'Organization',
    organizationName: 'Organization name',
    returnToDashboard: 'Return to Dashboard',
    you: 'You',
    yourContact: 'This is your contact profile',
    returnHome: 'Return Home',
    authenticated: 'Authenticated',
    revokeCredentials: 'Revoke credentials',
    inviteToPlatform: 'Invite to platform',
    selectAllThatApply: 'Select all that apply',
    selectAll: 'Select all',
    reset: 'Reset',
    surveyType: 'Survey Type',
    ok: 'Ok',
    close: 'Close',
    dontKnow: "Don't know",
    preferNotToAnswer: 'Prefer not to answer',
    discardUnsavedChanges: 'Discard Unsaved Changes',
    notPermitted: 'You do not have permission to edit this field.',
    startOnboardingDescription:
        "You will now begin the onboarding process for this organization. To begin, please click the 'Start Onboarding' button below.",
    startOnboarding: 'Start Onboarding',
    questionHighlightedForClientsAttention: 'Question highlighted for clients attention in latest review.',
    links: {
        privacyPolicy: 'https://cictucson.org/privacy/',
        termsAndConds: 'https://cictucson.org/terms/',
        contactEmail: 'lending@cictucson.org'
    },
    statuses: {
        'In Progress': 'In Progress',
        Pending: 'Pending',
        Submitted: 'Submitted',
        Upcoming: 'Upcoming',
        Accepted: 'Accepted',
        Rejected: 'Requires Adjustment'
    },
    surveyTriggers: {
        intake: 'Intake',
        biannual: 'Biannual',
        termination: 'Termination',
        onboarding: 'Onboarding',
        financial: 'Financial'
    },
    associatedUser: 'Associated User'
};
